import { parseAsString, useQueryState } from 'nuqs';
import { useEffect, useMemo } from 'react';
import { useApi } from '../providers/api-provider';
import { useUserSettingsStore } from '../stores/user-settings-store';

// The name of the search query parameter with a referral code.
const REFERRAL_CODE_PARAMETER = 'referral_code';

// The referral url is constructed from the base url and this path.
const REFERRAL_PATH = '/';

export function extractReferralCode(url: string) {
  try {
    const urlData = new URL(url);
    const referralCode = urlData.searchParams.get(REFERRAL_CODE_PARAMETER);
    return referralCode;
  } catch (error) {
    console.error('Invalid request URL', error);
    return null;
  }
}

const constructReferralUrl = (referralCode: string) => {
  const referralUrl = new URL(REFERRAL_PATH, window.location.origin);
  referralUrl.searchParams.set(REFERRAL_CODE_PARAMETER, referralCode);
  return referralUrl.toString();
};

export const useReferralCode = () => {
  const [urlReferralCode, setUrlReferralCode] = useQueryState(
    REFERRAL_CODE_PARAMETER,
    parseAsString,
  );
  const { setReferralCode } = useUserSettingsStore();

  // Store referral code in local storage if it exists in the url and then
  // remove it from the url.
  useEffect(() => {
    if (!urlReferralCode) return;
    setReferralCode(urlReferralCode);
    setUrlReferralCode(null);
  }, [urlReferralCode, setReferralCode, setUrlReferralCode]);
};

export const useReferralUrl = () => {
  const { api } = useApi();
  const { data } = api.useGetProfile();

  const referralUrl = useMemo(() => {
    if (!data?.referral_code) return null;
    return constructReferralUrl(data.referral_code);
  }, [data?.referral_code]);

  return referralUrl;
};
